module.exports = __webpack_public_path__ + "static/img/pic_pdfyauso_132＊132@2x.73403a1e.png";